import React from "react";
// components
import MNPGV2 from "./MNPGV2";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG003 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG003.rendered", props);

    if ( !props.template ) return null;

    return (
        <nav className="navbar navbar-expand-md">
            <div className="container-fluid">
                <MNPGV2 templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} />
            </div>
        </nav>
    )
}

const Component = React.memo(MNPG003, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG003.memo", { prevProps, nextProps });
    return true;
});

export default Component;
